export default "__VITE_ASSET__B2tD7h2W__"